// extracted by mini-css-extract-plugin
module.exports = {"teamName":"HomeTeamName_teamName__1BRq2"};